import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

import {  GenericValue, HisNotificationService, HisBaseGlobalsService, HisUiService } from 'hisng';

import { SEARCH_CONFIG_MINI_PROJECT } from 'app/fs/res/common/model/searchConstants';
import { ResearchPartner, ResearchPartnerSimple } from 'app/fs/res/common/model/researchPartner/researchPartner';
import { ResearchContract } from 'app/fs/res/common/model/finance/research-contract-classes';
import { BudgetSource } from 'app/fs/res/finance/model/budget-source/budget-source';

@Component({
    selector: 'res-funding-program-create-dialog',
    templateUrl: './funding-program-create-dialog.component.html',
})

export class FundingProgramCreateDialogComponent implements OnInit {
    @Input() fundingProgram: ResearchContract;
    @Input() display = false;
    @Output() displayChange: EventEmitter<boolean> = new EventEmitter();
    @Output() fundingProgramChange: EventEmitter<ResearchContract> = new EventEmitter();

    public currentContract: ResearchContract = new ResearchContract();
    public newResearchPartner = new ResearchPartner();

    public isAddOrganization = true;
    public createOrganizationDialogVisible = false;

    readonly SEARCH_CONFIG_MINI_PROJECT = SEARCH_CONFIG_MINI_PROJECT;
    public dateFormat: string;

    constructor( private notificationService: HisNotificationService,
        private hisUiService: HisUiService,
        private hisBaseGlobalsService: HisBaseGlobalsService ) {
    }

    ngOnInit() {
        if ( this.fundingProgram == null ) {
            this.currentContract.budgetSource = new BudgetSource();
        } else {
            // we need to assign a copy of the original object without reference
            Object.assign( this.currentContract, this.fundingProgram );
            this.isAddOrganization = false;
        }
    }

    public getOrganizations() {
        if(this.currentContract.budgetSource.researchPartner){
            return new Array<ResearchPartnerSimple>(this.currentContract.budgetSource.researchPartner);
        } else {
            return [];
        }
    }

    public externalOrganizationsChange(event: ResearchPartnerSimple[]) {
        this.currentContract.budgetSource.researchPartner = event[0];
        this.currentContract.funderName = event[0].defaulttext;
        this.isAddOrganization = false;
    }

    public createExternalOrgUnitChange() {
        this.createOrganizationDialogVisible = true;
    }

    public deleteOrganizationChange(event: GenericValue | ResearchPartnerSimple): void {
        this.currentContract.budgetSource.researchPartner = null;
        this.currentContract.funderName = null;
        this.isAddOrganization = true;

    }

    public confirmDialog() {
        if (this.areFieldsValid()) {
            this.fundingProgramChange.emit(this.currentContract);
            this.displayChange.emit(false);
        }
    }

    public closeDialog() {
        this.displayChange.emit(false);
    }

    public saveCreateOrganizationDialogChange(event: ResearchPartnerSimple) {
        this.currentContract.budgetSource.researchPartner = event;
        this.currentContract.funderName = event.defaulttext;
        this.isAddOrganization = false;
        this.createOrganizationDialogVisible = false;
    }

    private areFieldsValid(): boolean {
        this.notificationService.clear();
        let areFieldsValid = true;
        let inputRequired = this.hisUiService.translate('validation.required');
        let messages = [];
        if (!this.currentContract.budgetSource.researchPartner) {
            areFieldsValid = false;
            let ddKeyBudgetSourceResearchPartner = 'fs.res.finance.researchContract_publication.budgetSource.researchPartner';
            messages.push(`${this.hisUiService.translate(
                this.hisBaseGlobalsService.getDd(ddKeyBudgetSourceResearchPartner).labeltextIdentifier
            )}: ${inputRequired}`);
        }
        if (!this.currentContract.externalReferenceNumber?.trim().length) {
            areFieldsValid = false;
            let ddKeyExternalReferenceNumber = 'fs.res.finance.researchContract_publication.externalReferenceNumber';
            messages.push(`${this.hisUiService.translate(
                this.hisBaseGlobalsService.getDd(ddKeyExternalReferenceNumber).labeltextIdentifier
            )}: ${inputRequired}`);
        }
        if (!areFieldsValid) {
            this.notificationService.error(
                messages,
                this.hisUiService.translate('global.validationerror')
            );
        }
        return areFieldsValid;
    }
}
